import { call, put, takeLatest } from "redux-saga/effects";

import { apiGetUserInfo } from "helpers/api/master/auth";
import Cookies from "js-cookie";
import {
  GET_USER_INFO,
  actGetUserInfoFailed,
  actGetUserInfoSuccess,
} from "store/actions/auth";
import { showToastError } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetUserInfo(action) {
  try {
    const response = yield call(apiGetUserInfo, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actGetUserInfoSuccess(response));

      Cookies.set(
        "USER_INFO",
        JSON.stringify({
          ...response?.data,
        })
      );

      if (action.onSuccess) {
        yield action.onSuccess(response?.data);
      }
    }
  } catch (error) {
    yield put(actGetUserInfoFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchUserInfo() {
  yield takeLatest(GET_USER_INFO, doGetUserInfo);
}
